export const faAlignLeft = {
  prefix: 'fpm',
  iconName: 'fa-align-left',
  icon: [
    24,
    24,
    [],
    'e001',
    'M4 12.32v9.32h1V3H4v9.32m2.28-3.6v1.96h8.52V6.76H6.28v1.96m0 7.2v1.96h13.08v-3.92H6.28v1.96',
  ],
};
